import { render, staticRenderFns } from "./StepTwo.vue?vue&type=template&id=6d996b82&"
import script from "./StepTwo.vue?vue&type=script&lang=js&"
export * from "./StepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d996b82')) {
      api.createRecord('6d996b82', component.options)
    } else {
      api.reload('6d996b82', component.options)
    }
    module.hot.accept("./StepTwo.vue?vue&type=template&id=6d996b82&", function () {
      api.rerender('6d996b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Installer/StepTwo.vue"
export default component.exports